
const booking = {
    name: 'Nombre',
    description: 'Descripción',
    allowReservations: 'Permitir reservas',
    reservationRequired: 'Reservation required',
    reservable: 'Reservable',
    PVPHosted: 'Price hosted',
    PVPNoHosted: 'Price no hosted',
    noEvents: 'There are no other activities scheduled for today',
    moreInfo: '+ info',
    cancelReservation: 'Cancel r.',
    reservation: 'Booking',
    addCalendar: '+ CAL',
    place: 'Place',
    meetingPoint: 'Meeting point',
    lat: 'Latitud',
    lon: 'Longitud',
    complete: 'Completo',
    allowReservation: 'Permitir reservar',
    imagesFolder: 'Carpeta de imágenes',
    pleaseStandBy: 'Please stand by',
    filter: 'Filter',
    info: 'Info',
    typeLimit: {
      days: 'days',
      hours: 'hours',
      minutes: 'minutes',
      from: 'from',
      to: 'to',
      before: 'before',
      canBeReserved: 'You can book',
    },
    acttiv: {
      hotel: 'Hotel',
    },
    activities: {
      title: 'Actividades',
      addActivity: 'Añadir actividad',
      editActivity: 'Editar actividad',
      seats: 'Plazas',
    },
    schedules: {
      title: 'Programaciones',
      addSchedule: 'Añadir programación',
    },
    scheduleForm: {
      title: 'Programa',
      alias: 'Alias',
      startTime: 'Hora inicio',
      interval: 'Intervalo',
      type: 'Tipo',
      byDay: 'Por fechas',
      byWeek: 'Por semanas',
      byMonth: 'Por mes',
      allDay: 'Todo el día',
      duration: 'Duración',
    },
    formFields: {
      owner: 'Comprador',
      pax: 'Asistente',
      title: 'Campos del formulario',
      name: 'Nombre',
      lastName: 'Apellidos',
      email: 'Email',
      fullName: 'Nombre completo',
      phone: 'Teléfono',
      room: 'Habitación',
      locale: 'Idioma',
      age: 'Edad',
      allergens: 'Alérgenos',
      observations: 'Observaciones',
      add: 'Añadir',
      type: 'Tipo',
    },
    calendar: {
      today: 'Hoy',
      day: 'Día',
      week: 'Semana',
      month: 'Mes',
      fourDays: '4 días',
      available: 'Disponibles',
      reserved: 'Reservadas',
      canceled: 'Canceladas',
      goToReservationList: 'Ir al listado de reservas', 
    },
    notifications: {
      title: 'Notificaciones',
      sendOwnerMail: 'Enviar email de reserva al cliente',
    },
    reservations: {
      title: 'Reservation',
      numPax: 'Nº pax',
      field: 'Field',
      addReservation: 'Add reservation',
      editReservation: 'Edit reservation',
      clientData: 'Client data',
      paxData: 'Participant data',
      addPax: 'Add participant',
      pax: 'Participant',
      owner: 'Client',
      time: 'Time',
      activity: 'Activity',
      cu: 'Creado por',
      lmu: 'Actualizado por',
      withBooks: 'con reservas',
      withCancelBooks: 'con reservas canceladas',
      required: 'Requerido',
      key: 'Identificador interno',
      label: 'Etiqueta',
      exceededCapacity: 'Exceeded capacity',
      limitFieldsTime: 'Límite de reservas por cliente excedido',
      adultsPax: 'Adults',
      childrensPax: 'Childrens',
      babiesPax: 'Babies',
      rate: 'Rate',
      activityColor: {
        typeColor: 'Tipo',
        weekPrimaryColor: 'Semana primario',
        weekSecondaryColor: 'Semana secundario',
        contentColor: 'Color contenido',
        titleColor: 'Color título',
        timeColor: 'Color hora',
      },
      formFieldsTypes: {
        title: 'Tipo',
        text: 'Texto',
      },
      status: {
        title: 'Estado',
        default: 'Reservado',
        canceled: 'Cancelado',
      },
      messages: {
        fieldRequired: 'Required',
        fieldNotValid: 'Not valid',
        noData: 'There are no reservations for the selected date',
        noEventsForSelectedDate: 'There are no events for the selected date',
        statusCanceledNoEditable: 'Las reservas canceladas no se pueden editar',
        exceededCapacity: 'Aforo excedido',
        limitFieldsTime: 'Límite de reservas por cliente excedido',
        resourceNotAvailable: 'Recurso no disponible',
      },
    },
}
export default booking
